import { readBuiltInSkillFiles } from "./readSkill.macro" with { type: "macro" };
import { parseSkills } from "./catalog";

export const skillFiles: Record<string, string> = readBuiltInSkillFiles();

export const skills = parseSkills(skillFiles);

export const FRONTEND_DESIGN_SKILL = "frontend-design";
